export const GET_SESSION_SECTIONS = "GET_SESSION_SECTIONS";
export const GET_SESSION_SECTION_BY_ID = "GET_SESSION_SECTION_BY_ID";
export const UPDATE_SESSION_SECTION = "UPDATE_SESSION_SECTION";
export const DELETE_SESSION_SECTION = "DELETE_SESSION_SECTION";
export const CREATE_SESSION_SECTION = "CREATE_SESSION_SECTION";
